module.exports = __webpack_public_path__ + "static/media/long_and_short_exposure.9c84d8f4.png";